<template>
  <div
    v-if="!cookieAccepted"
    class="app-cookie"
  >
    <div class="text">
      {{ $t('cookie-bar.text') }}
      <a
        class="cgu-link"
        :href="cguLink"
        target="_blank"
      >
        {{ $t('cookie-bar.link') }}
      </a>
    </div>
    <x-button
      class="md-raised outline"
      @click="acceptCookie"
    >
      {{
        $t('cookie-bar.button')
      }}
    </x-button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'AppCookie',
  computed: {
    ...mapState({
      cookieAccepted: ({ cookieAccepted }) => cookieAccepted
    }),

    cguLink() {
      return `https://esr.conseil.wesave.fr/cgu`
      // return `${process.env.SITE_URL}/cgu`
    }
  },
  methods: {
    ...mapMutations({
      acceptCookie: 'acceptCookie'
    })
  }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">
@import '~@/styles/vars.scss';

.app-cookie {
  z-index: 99;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background-color: map_get($palette-primary, main);
  color: white;
  padding: $space-small $space-big;
  display: flex;
  align-items: center;
  justify-content: center;

  .cgu-link {
    text-decoration: underline;
    font-weight: 600;
  }

  .button {
    color: map_get($palette-primary, text) !important;
    border-color: map_get($palette-primary, text) !important;
    background-color: transparent !important;
    margin-left: $space-medium;
    transition: all 300ms;
  }
}
</style>
